/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__recommendations = /** @type {(inputs: {}) => string} */ () => {
	return `Unsere Tipps`
};

const en_route_details__recommendations = /** @type {(inputs: {}) => string} */ () => {
	return `To discover`
};

const es_route_details__recommendations = /** @type {(inputs: {}) => string} */ () => {
	return `A descubrir`
};

const fr_route_details__recommendations = /** @type {(inputs: {}) => string} */ () => {
	return `À découvrir`
};

const it_route_details__recommendations = /** @type {(inputs: {}) => string} */ () => {
	return `Da scoprire`
};

const nl_route_details__recommendations = /** @type {(inputs: {}) => string} */ () => {
	return `Te ontdekken`
};

const pt_route_details__recommendations = /** @type {(inputs: {}) => string} */ () => {
	return `Para descobrir`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__recommendations = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__recommendations(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__recommendations", locale)
	if (locale === "de") return de_route_details__recommendations(inputs)
	if (locale === "en") return en_route_details__recommendations(inputs)
	if (locale === "es") return es_route_details__recommendations(inputs)
	if (locale === "fr") return fr_route_details__recommendations(inputs)
	if (locale === "it") return it_route_details__recommendations(inputs)
	if (locale === "nl") return nl_route_details__recommendations(inputs)
	return pt_route_details__recommendations(inputs)
};